import legalDocuments from '../footer-commons/legal-documents/legal-documents.vue';
import footerBase from '../footer-commons/lib/footer-base';
export default {
	extends: footerBase,
	components: {
		legalDocuments
	}
};
